import React, { Component } from 'react';
import Link from 'gatsby-link';
import $ from 'jquery';
import { slugify } from '../components/slugify';
import isotope from 'isotope-layout';
import ItemGrid from '../components/isotopify.js';


class IsotopeFilterLinks extends Component{

    render() {
        return (
            <div>
                <div className="IsotopeFilter">
                    <div style={{ display: 'block', width: '100%' }}>
                        <div>
                                    <button data-filter="*">Alle</button>
                                    <button data-filter={slugify("Geotechnik und Geologie Grund- und Spezialtiefbau")}>Geotechnik und Geologie, Grund- und Spezialtiefbau</button>
                                    <button data-filter={slugify("Tunnelbau und Rohrleitungsbau")}>Tunnelbau und Rohrleitungsbau</button>
                                    <button data-filter={slugify("Umweltgeotechnik und Energie")}>Umweltgeotechnik und Energie</button>
                                    <button data-filter={slugify("Kampfmittelräumung")}>Kampfmittelr&auml;umung</button>
                                    <button data-filter={slugify("Wasserbau")}>Wasserbau</button>
                                    <button data-filter={slugify("Verkehrswegebau")}>Verkehrswegebau</button>
                                    <button data-filter={slugify("Schulung und Weiterbildung")}>Schulung und Weiterbildung</button>
                        </div>
                    </div>
                </div>
            </div>
        )
}
}

const FilterLink = props => (
    <li className="IsoFilter" style={{ display: `inline-block`, marginRight: `1rem` }}>
        <Link to={props.children}>
            {props.children}
        </Link>
    </li>
)

export default IsotopeFilterLinks;



// WEBPACK FOOTER //
// ./src/components/isofilter.js